// extracted by mini-css-extract-plugin
module.exports = {"paper":"Loading_paper__IT1bV","content":"Loading_content__2QPPF","logo":"Loading_logo__38g8z","text":"Loading_text__26S-Q","loadingContainer":"Loading_loadingContainer__1Tsnh"};